<template>
    <div class="info-mosaics-container">
        <div class="global-mosaic-container">
          <div class="filter-global-container">
            <div class="panel-content-line">
                <input type="checkbox" id="global-mosaic-checkbox" name="global-mosaic-checkbox" v-model="mosaicsGlobal">
                <label for="global-mosaic-checkbox">Mosaico global</label>
            </div>
            <div class="panel-content-line">
                <input type="checkbox" id="campaigns-mosaic-checkbox" name="campaigns-mosaic-checkbox" v-model="mosaicsCampaigns">
                <label for="campaigns-mosaic-checkbox">Mosaicos por campaña</label>
            </div>
          </div>
          <form :model="form" ref="form" v-on:submit.prevent v-if="mosaicsCampaigns">
            <div class="filter-date-container">
              <div class="panel-content-line filter-element">
                  <label for="mosaic-start-date">Fecha inicio</label>
                  <br>
                  <input type="date" id="mosaic-start-date" name="mosaic-start-date" class="custom-input-text" v-model="form.mosaicStartDate">
              </div>
              <div class="panel-content-line filter-element">
                  <label for="mosaic-start-date">Fecha fin</label>
                  <br>
                  <input type="date" id="mosaic-end-date" name="mosaic-end-date" class="custom-input-text" v-model="form.mosaicEndDate">
              </div>
            </div>
            <div class="panel-content-line filter-element">
              <label for="campaign-filter">Búsqueda de campañas</label>
              <br>
              <input type="text" id="campaign-filter" name="campaign-filter" class="custom-input-text" v-model="form.campaignFilter">
            </div>
            <br>
            <button class="btn-new ml-auto" v-on:click="getFilteredMosaics">Filtrar</button>
          </form>
        </div>
    </div>
</template>

<script>
  import {getData} from './../../services/api'

  export default {
    name: 'filterPanelMosaics',
    data() {
        return {
          form: {
            mosaicStartDate: '',
            mosaicEndDate: '',
            campaignFilter: ''
          }
        }
    },
    computed: {
      mosaicsGlobal: {
          set () { this.$store.dispatch('changeMosaicsGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsGlobal }
      },
      mosaicsCampaigns: {
          set () { this.$store.dispatch('changeMosaicsGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaigns }
      },
      mosaicsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsList', {mosaicsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsList }
      },
      mosaicsCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsListFiltered', {mosaicsCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsListFiltered }
      }
    },
    beforeMount () {
        this.getMosaicData()
    },
    methods: {
      getMosaicData: function () {
          var url = 'mmdata/mosaic-campaigns/'
          getData(url).then(res=> {
              this.mosaicsCampaignsList = res.data.mosaicCampaigns
              this.mosaicsCampaignsListFiltered = res.data.mosaicCampaigns
          })
      },
      getFilteredMosaics: function () {
        var start = '2000-01-01'
        var end = 'now'
        var campFilter = 'no filter'
        if(this.form.mosaicStartDate != '') start = this.form.mosaicStartDate
        if(this.form.mosaicEndDate != '') end = this.form.mosaicEndDate
        if(this.form.campaignFilter != '') campFilter = this.form.campaignFilter
        var url = 'mmdata/mosaic-campaigns-filtered/' + start + '/' + end + '/' + campFilter + '/'

        getData(url).then(res=> {
          this.mosaicsCampaignsListFiltered = res.data.mosaicCampaigns
        })
        .catch(error => {
          this.$noty.error("Error")
        })
      }
    }
  }
</script>

<style scoped>
  .info-mosaics-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-mosaic-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
  }
  .filter-date-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-global-container {
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-element {
    flex: 1;
    margin: 0.3rem;
  }
  .custom-input-text{
    background-color: #f9f9f9;
    font-size: 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: .375rem 1.75rem .375rem .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/FilterPanelMosaics.vue